import type { PromoteRevisionResponse } from "../../service/SpecsRevisionService";

export function formatPromotionSuccessMessage(
  promotion: PromoteRevisionResponse
) {
  const promotedRevisionId = String(promotion.revisionId ?? "");
  if (!promotedRevisionId) {
    throw new Error("Missing promoted revision id");
  }

  const nextEnv = promotion.nextEnv?.trim() || "next env";
  return `Promoted revision ${promotedRevisionId.slice(0, 8)} to ${nextEnv}`;
}
